<template>
  <div>
    <PostGalleryPreviewMobile :post="post" v-if="isMobile" />
    <PostGalleryPreviewDesktop :post="post" v-else />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from "vue"
import { Post } from "suus-api"
import { useIsBreakpointInNames } from "features/common/vuetify/useVuetify"
import PostGalleryPreviewDesktop from "features/posts/gallery/PostGalleryPreviewDesktop.vue"
import PostGalleryPreviewMobile from "features/posts/gallery/PostGalleryPreviewMobile.vue"
import TextButton from "components/UI/TextButton.vue"
import Button from "components/UI/Button.vue"

export default defineComponent({
  name: "PostGalleryPreview",
  components: {
    Button,
    TextButton,
    PostGalleryPreviewMobile,
    PostGalleryPreviewDesktop,
  },
  props: {
    post: {
      type: Object as PropType<Post>,
      required: true,
    },
  },
  setup(props) {
    const isMobile = useIsBreakpointInNames(["xs", "sm"])

    const buttonStyles = computed(() =>
      isMobile.value ? { width: "100%" } : {}
    )

    return {
      isMobile,
      buttonStyles,
    }
  },
})
</script>
